import { SET_IS_NEW_DESIGN } from "./settingsActions";

const INITIAL_STATE = { isNewDesign: false, template: "default" };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_IS_NEW_DESIGN:
      return {
        ...state,
        isNewDesign: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/settings/settingsReducer.js